import { Card, Col, Form, Input, Row } from "@pankod/refine-antd";
import { FC } from "react";
import { MyFormProps } from ".";

export const IncludeAndEditCampaignForm: FC<MyFormProps> = ({ formProps }) => {
  return (
    <Card>
      <Form layout="vertical" {...formProps} style={{ padding: 16 }}>
        <Row gutter={16}>
          <Col xs={24}>
            <Form.Item
              label="Campanha"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Nome da campanha é obrigatório",
                  min: 1,
                },
              ]}
            >
              <Input className="input-custom ant-input" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};
